import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as s } from "../../../../IconBase-CxZyIWw2.js";
const l = i((r, e) => /* @__PURE__ */ o.jsx(
  s,
  {
    ref: e,
    ...r,
    image: (t) => /* @__PURE__ */ o.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...t,
        children: [
          /* @__PURE__ */ o.jsx(
            "circle",
            {
              cx: 12,
              cy: 12,
              r: 10.5,
              stroke: "currentColor",
              strokeWidth: 3
            }
          ),
          /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "m12 11.904-2.798 2.798L8 13.5l4-4 4 4-1.202 1.202z",
              clipRule: "evenodd"
            }
          )
        ]
      }
    )
  }
));
l.displayName = "AccordionCaretUpIcon";
export {
  l as AccordionCaretUpIcon,
  l as default
};
//# sourceMappingURL=index.js.map
